require('../../pricing/plans/plansService');
require('../../fhApp/currentUser/currentUser');
require('../../fhApp/serviceBreakerService');
require('../../shared/teamService');
require('../../fhApp/productService');

"use strict";

angular.module('app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController', [
  'app.pricing.plans.plansService',
  'app.currentUser',
  'app.serviceBreakerService',
  'app.shared.teamService',
  'app.productService'
])
  .controller('app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController', [
    '$scope',
    'app.pricing.plans.plansService',
    'currentUser',
    'app.serviceBreakerService',
    'app.shared.teamService',
    '$timeout',
    '$filter',
    '$rootScope',
    'app.productService',
    'PRODUCT',
    function ($scope, pricingPlans, currentUser, serviceBreakerService, teamService, $timeout, $filter, $rootScope, productService, PRODUCT) {
      //$scope variables assigned through directive
      $scope.showManage = $scope.showManage || false;
      $scope.currentSubscription = $scope.currentSubscription || null;
      $scope.plans = $scope.plans || null;
      $scope.fetchPlans = $scope.fetchPlans || false;
      $scope.fetchSubscription = $scope.fetchSubscription || false;
      $scope.useServiceBreaker = $scope.useServiceBreaker || false;

      //$scope variables used primarily for html view
      $scope.breakers = serviceBreakerService.breakers;
      $scope.planCards = [];

      let teams = [];
      let currentSubscriptionWatcher = null;
      let plansWatcher = null;
      let timer;

      let buildPlanCards = () => {
        let planCards = [];

        sortPlans();

        if ($scope.currentSubscription) {
          if (($scope.currentSubscription.subscription_upgrades && $scope.currentSubscription.state === 'active') ||
            ($scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled())) {

            planCards.push({
              cardType: 'upgrade',
              currentSubscription: $scope.currentSubscription,
              planTeams: teams,
              planGroups: getPlanGroups(),
            });
          }

          if ($scope.currentSubscription.state === 'active'
            && $scope.currentSubscription.is_suspended
          ) {
            planCards.push({
              plan: $scope.currentSubscription.plan,
              cardType: 'resume'
            });
          }

          if ($scope.currentSubscription.state === 'canceled'
          ) {
            planCards.push({
              plan: $scope.currentSubscription.plan,
              cardType: 'renew'
            });
          }

          /*if (!$scope.currentSubscription.subscription_upgrades && productService.cannotUpgradeSubscription()) {
            let invalidUpgradeIndex = planCards.findIndex((subscription_plan) => {
              return subscription_plan.cardType === 'cannot-upgrade'
            });

            if (invalidUpgradeIndex <= -1) {
              planCards.push({
                plan: $scope.currentSubscription.plan,
                cardType: 'cannot-upgrade'
              });
            }
          }*/

          if ($scope.currentSubscription.state === 'active'
            && !$scope.currentSubscription.is_suspended
          ) {
            planCards.push({
              plan: $scope.currentSubscription.plan,
              cardType: 'cancel'
            });
          }

          if ($scope.currentSubscription.state === 'active'
            && !$scope.currentSubscription.is_suspended
            && $scope.currentSubscription.is_suspendable
          ) {
            planCards.push({
              plan: $scope.currentSubscription.plan,
              cardType: 'suspend'
            });
          }
        } else {
          let multiPlans = [];

          _.forEach($scope.plans, (plan) => {
            switch (PRODUCT.Code) {
              case 'ahl':
                switch (plan.type) {
                  case 'league':
                  case 'global':
                  case 'team_all':
                    planCards.push({
                      plan: plan,
                      cardType: 'singlePlan',
                      useTeams: planUsesTeams(plan),
                      planTeams: teams,
                    });
                    break;
                  case 'team_home':
                  case 'team_away':
                    let planObj = angular.copy(plan);
                    planObj.multiPlanType = 'teams';
                    planObj.commonPlanAttrs = {
                      name: 'Home OR Away Single Team Pass',
                      description: planObj.description,
                      total_price: planObj.total_price,
                      currency_symbol: planObj.currency_symbol,
                    };

                    multiPlans.push(planObj);
                    break;
                }
                break;
              case 'htv':
                switch (plan.type) {
                  case 'global':
                    planCards.push({
                      plan: plan,
                      cardType: 'singlePlan',
                      useTeams: planUsesTeams(plan),
                      planTeams: teams,
                    });
                    break;
                }
                break;
            }
          });

          if (multiPlans.length) {
            multiPlans = _.groupBy(multiPlans, 'multiPlanType');

            _.forEach(multiPlans, (multiPlan) => {
              let plans = [];

              _.forEach(multiPlan, (plan) => {
                plans.push(plan);
              });

              planCards.push({
                cardType: 'multiPlan',
                useTeams: planUsesTeams(multiPlan[0]),
                planTeams: teams,
                commonPlanAttrs: multiPlan[0].commonPlanAttrs,
                plans: plans
              });
            });
          }
        }

        if ($scope.showManage && $scope.currentSubscription) {
          planCards.push({
            cardType: 'manageBilling',
            currentSubscription: $scope.currentSubscription,
          });
        }

        $scope.planCards = planCards;
      };

      let sortPlans = () => {
        return _.sortBy($scope.plans, ['type', 'unit_price']);
      };

      let planUsesTeams = (plan) => {
        switch (PRODUCT.Code) {
          case 'ahl':
            switch (plan.type) {
              case 'league':
              case 'global':
              default:
                return false;
              case 'team_all':
              case 'team_home':
              case 'team_away':
                return true;
            }
            break;
          case 'htv':
            switch (plan.type) {
              case 'global':
              default:
                return false;
            }
        }
      };

      let getPlanGroups = () => {
        let planGroups = {
          unlimitedAccess: { title: null, plans: [], sortOrder: 0, hasTeams: false },
          teamAccess: { title: null, plans: [], sortOrder: 0, hasTeams: false }
        };
        let plans = [];
        let upgradeablePlanCodes = $scope.currentSubscription.subscription_upgrades;

        if ($scope.currentSubscription.state === 'active' && upgradeablePlanCodes) {
          _.forEach($scope.plans, (plan) => {
            if (upgradeablePlanCodes.indexOf(plan.plan_code) > -1) {
              plans.push(plan)
            }
          });
        } else if ($scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled()) {
          _.forEach($scope.plans, (plan) => {
            if ($scope.currentSubscription.plan.plan_code !== plan.plan_code) {
              plans.push(plan)
            }
          });
        } else {
          plans = $scope.plans;
        }

        _.forEach(plans, (plan) => {
          switch (PRODUCT.Code) {
            case 'ahl':
              switch (plan.type) {
                case 'league':
                case 'global':
                  if (!planGroups.unlimitedAccess.title) {
                    planGroups.unlimitedAccess.title = 'Unlimited Access';
                  }

                  if (!planGroups.unlimitedAccess.sortOrder) {
                    planGroups.unlimitedAccess.sortOrder = 1;
                  }

                  planGroups.unlimitedAccess.plans.push(plan);
                  break;
                case 'team_all':
                case 'team_home':
                case 'team_away':
                  if (!planGroups.teamAccess.title) {
                    planGroups.teamAccess.title = 'Single Team Access';
                  }

                  if (!planGroups.teamAccess.sortOrder) {
                    planGroups.teamAccess.sortOrder = 2;
                  }

                  if (!planGroups.teamAccess.hasTeams) {
                    planGroups.teamAccess.hasTeams = true;
                  }

                  planGroups.teamAccess.plans.push(plan);
                  break;
              }
              break;
            case 'htv':
              switch (plan.type) {
                case 'global':
                  if (!planGroups.unlimitedAccess.title) {
                    planGroups.unlimitedAccess.title = 'Unlimited Access';
                  }

                  if (!planGroups.unlimitedAccess.sortOrder) {
                    planGroups.unlimitedAccess.sortOrder = 1;
                  }

                  planGroups.unlimitedAccess.plans.push(plan);
                  break;
              }
              break;
          }
        });

        planGroups = _.values(planGroups);

        console.log(planGroups);

        return planGroups
      };

      let init = () => {
        if (productService.useTeamSubscriptions()) {
          teamService.getTeams().then(
            function (response) {
              let data = response.data;

              if (data) {
                if (data.error) {
                  alert(data.error)
                } else {
                  teams = data;
                  startWatchers();
                }
              }
            }
          );
        } else {
          startWatchers();
        }

        checkBreaker();
      };

      let checkBreaker = () => {
        if ($scope.useServiceBreaker) {
          serviceBreakerService.checkRecurly()
            .then(() => {
              timer = $timeout(
                () => {
                  checkBreaker();
                },
                60000
              );
            });
        }
      };

      let startWatchers = () => {
        currentSubscriptionWatcher = $scope.$watch(() => {
          return $scope.currentSubscription;
        }, () => {
          let alreadyPrepped = false;

          if ($scope.fetchSubscription && !$scope.currentSubscription) {
            currentUser.get_current_subscriptions('recurly').then(() => {
              $scope.currentSubscription = currentUser.subscriptions.recurly;
              buildPlanCards();
              alreadyPrepped = true;
            });
          }

          if (!alreadyPrepped) {
            buildPlanCards();
          } else {
            alreadyPrepped = false;
          }
        });

        plansWatcher = $scope.$watch(() => {
          return $scope.plans;
        }, () => {
          let alreadyPrepped = false;

          if ($scope.fetchPlans && !$scope.plans) {
            pricingPlans.retrieve(null, { sort: 'active' }).then(() => {
              $scope.plans = pricingPlans.list;
              buildPlanCards();
              alreadyPrepped = true;
            });
          }

          if ($scope.plans && !alreadyPrepped) {
            buildPlanCards();
          }

          if (alreadyPrepped) {
            alreadyPrepped = false;
          }
        });
      };

      $scope.$on('$destroy', function () {
        $timeout.cancel(timer);
      });

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/teamSubscriptionPurchaseForm/teamSubscriptionPurchaseController.js